var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownload = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "download_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.325 16.7c.09.09.2.17.32.22s.25.08.39.08c.09 0 .17-.03.26-.05.17-.05.33-.12.45-.25l4.74-4.84a.987.987 0 0 0-.02-1.41.987.987 0 0 0-1.41.02l-3.03 3.09V4c0-.55-.45-1-1-1s-1 .45-1 1v9.57l-3.11-3.15a.987.987 0 0 0-1.41 0 .987.987 0 0 0 0 1.41l4.83 4.87z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.995 18.78V16c0-.55-.45-1-1-1s-1 .45-1 1v2.78c0 .12-.1.22-.22.22H5.215c-.12 0-.22-.1-.22-.22V16c0-.55-.45-1-1-1s-1 .45-1 1v2.78c0 1.22.99 2.22 2.22 2.22h13.57c1.22 0 2.22-.99 2.22-2.22z"
})));
export default SvgDownload;